/* TODO-283: Tablet Collection Filter - Drawer Mode Fix v3
   Problem: theme.js getShowOnLoad() tablet'te (768-1023px) filter'i auto-open
   yapiyor cunku theme.sizes.medium=768. CSS drawer'i gorsel olarak gizliyor ama
   JS state "expanded" kaliyor.
   
   Cozum:
   1. Page load'da filter state'ini resetle (cift-tiklama fix)
   2. Body'ye overlay ekle + filter outer'a close butonu ekle
   3. MutationObserver ile drawer--visible class toggle'ini izle
*/
(function(){
  var w = window.innerWidth;
  if (w < 768 || w >= 1024) return;

  var wrapper, toggleKey, filterToggleBtn, overlay;

  function getElements() {
    wrapper = document.querySelector('[data-collection-sidebar]');
    if (!wrapper) return false;
    toggleKey = wrapper.getAttribute('data-filters');
    if (toggleKey) {
      filterToggleBtn = document.querySelector('[data-filters-toggle="' + toggleKey + '"]');
    }
    return true;
  }

  function closeDrawer() {
    if (filterToggleBtn && wrapper && wrapper.classList.contains('drawer--visible')) {
      filterToggleBtn.click();
    }
  }

  function syncOverlay() {
    if (!overlay || !wrapper) return;
    if (wrapper.classList.contains('drawer--visible')) {
      overlay.style.display = 'block';
      document.body.style.overflow = 'hidden';
    } else {
      overlay.style.display = 'none';
      document.body.style.overflow = '';
    }
  }

  function setupDrawerControls() {
    if (!wrapper) return;

    // Overlay on body
    if (!overlay) {
      overlay = document.createElement('div');
      overlay.className = 'bcb-tablet-overlay';
      overlay.style.cssText = 'display:none;position:fixed;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,0.4);z-index:20040;cursor:pointer;';
      overlay.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        closeDrawer();
      });
      document.body.appendChild(overlay);
    }

    // Close button inside filter outer
    var outer = wrapper.querySelector('.collection__filters__outer');
    if (outer && !outer.querySelector('.bcb-tablet-close')) {
      var closeBtn = document.createElement('button');
      closeBtn.className = 'bcb-tablet-close';
      closeBtn.setAttribute('aria-label', 'Close filters');
      closeBtn.style.cssText = 'position:absolute;top:16px;right:16px;z-index:20060;width:40px;height:40px;display:flex;align-items:center;justify-content:center;background:transparent;border:none;cursor:pointer;color:#333;padding:0;border-radius:50%;';
      closeBtn.innerHTML = '<svg width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M1 1l16 16M17 1L1 17" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>';
      closeBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        closeDrawer();
      });
      outer.insertBefore(closeBtn, outer.firstChild);
    }

    // Watch for drawer--visible class changes
    var obs = new MutationObserver(function() {
      syncOverlay();
    });
    obs.observe(wrapper, { attributes: true, attributeFilter: ['class'] });
  }

  function resetFilterState() {
    if (!getElements()) return;

    wrapper.classList.remove('drawer--visible');
    wrapper.classList.remove('filters--default-visible');

    if (toggleKey) {
      var buttons = document.querySelectorAll('[data-filters-toggle="' + toggleKey + '"]');
      buttons.forEach(function(btn) {
        btn.setAttribute('aria-expanded', 'false');
        btn.classList.remove('drawer--visible');
        btn.classList.remove('filters--default-visible');
      });
    }

    setupDrawerControls();
    syncOverlay();
  }

  if (document.readyState === 'complete') {
    setTimeout(resetFilterState, 100);
  } else {
    window.addEventListener('load', function() {
      setTimeout(resetFilterState, 100);
    });
  }
})();
